module.exports = __webpack_public_path__ + "img/dragIndicator.0ca646d6.svg";